export default "__VITE_ASSET__ad920c7f__"